import { IconFormNames } from 'shared/assets/icons';

import { NewGoal } from './goal';
import { ID } from './id';
import { LocalizedString } from './localized-string';
import { MinimalNewTask } from './task';
import { Timestamp } from './timestamp';

export enum OnboardingSteps {
  Welcome = 'web-welcome',
  ToggleLifeAreas = 'web-toggle-life-areas',
  CreateGoals = 'web-create-goals',
  CreateHabits = 'web-create-habits',
  CreateTasks = 'web-create-tasks',
  WorkSituation = 'web-user-work-situation',
  HearAbout = 'web-user-hear-about',
  CreateAccount = 'web-create-account',
  Premium = 'web-premium',
}

export type OnboardingLifeArea = {
  id: ID;
  name: LocalizedString;
  iconName: IconFormNames;
  color: string;
};

export type OnboardingLocalizedLifeArea = {
  id: ID;
  name: string;
  iconName: IconFormNames;
  color: string;
};

export type OnboardingGoal = NewGoal & {
  id: ID;
};

export type OnboardingAnswers = {
  updatedAt?: Timestamp;
  lastShownStep: OnboardingSteps;
  archivedLifeAreas?: ID[];
  goals?: OnboardingGoal[];
  habits?: MinimalNewTask[];
  tasks?: MinimalNewTask[];
  workSituation?: string;
  hearAbout?: string;
};
